import React from 'react'
import { message, Tooltip } from '@surecompanies/core_components'

import { copyToClipboard } from 'components/CopyLink/CopyText'

import styles from './ReviewQueue.module.scss'

/**
 * A bare icon button that copies one string — the Token cell's value and the
 * row's shareable link both being that, at different sizes of string.
 */
const CopyIconButton: React.FC<{
  value: string
  /** Screen-reader name. Distinct per use, so a row's two copy buttons are told apart. */
  label: string
  tooltip: string
  icon: React.ReactNode
  /**
   * Toast on success. Optional because copying a visible value (the Token
   * cell) is self-evident, while copying a link produces no visible change at
   * all. `copyToClipboard` raises its own toast on failure either way.
   */
  successMessage?: string
}> = ({ value, label, tooltip, icon, successMessage }) => (
  <Tooltip title={tooltip}>
    <button
      type="button"
      aria-label={label}
      className={styles.copyButton}
      onClick={() => {
        void copyToClipboard(value).then((copied) => {
          if (copied && successMessage) message.success(successMessage)
        })
      }}
    >
      {icon}
    </button>
  </Tooltip>
)

export default CopyIconButton
